import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/FamilyVisaOption.jpg";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaCheckCircle, FaClock, FaVoteYea, FaPassport, FaUsers, FaShieldAlt, FaGlobe, FaHeart, FaFileAlt, FaGraduationCap, FaCalendarAlt, FaMapMarkedAlt, FaUserCheck, FaFlag, FaAward, FaHandshake, FaCertificate } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import applicationProcess from "../../images/individual/application-proccess.svg";
import { Helmet } from "react-helmet-async";

const Citizenship = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Testimonials data for this specific page
  const testimonials = [
    {
      content: "Immiget Global made my citizenship journey effortless. From test prep to the ceremony, they handled everything!",
      name: "Priya",
      location: "Sydney",
      visaType: "Australian Citizenship"
    }
  ];

  const faqs = [
    {
      question: "Can I keep my original citizenship?",
      answer: "Yes, if your home country allows dual citizenship."
    },
    {
      question: "What if I fail the citizenship test?",
      answer: "You can retake it (unlimited attempts)."
    },
    {
      question: "Do children need to take the test?",
      answer: "No, only applicants aged 18-59."
    },
    {
      question: "How long does citizenship approval take?",
      answer: "Typically 6-12 months, but may vary."
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Australian Citizenship – Your Complete Guide to Becoming a Citizen - Immiget Global</title>
        <meta
          name="description"
          content="Become an Australian citizen with expert guidance. Citizenship by conferral, descent & marriage pathways. Test preparation & application support. Start your journey today."
        />
        <meta 
          name="keywords" 
          content="australian citizenship, citizenship by conferral, citizenship test, permanent residency, dual citizenship, citizenship ceremony" 
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Citizenship
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Family & Spouse
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Citizenship
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[30px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            Australian Citizenship – Your Complete Guide to Becoming a Citizen
          </h1>
          <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[22px] font-normal">
            Dreaming of becoming an Australian citizen? Australian citizenship offers lifetime rights, including voting, passport privileges, and unrestricted travel. At Immiget Global, we guide you through every step of the citizenship process for a smooth and successful application.
          </p>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="Australian Citizenship" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Become an Australian Citizen */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Why Become an Australian Citizen?
          </h1>
        </div>
        
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaVoteYea className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ Voting rights – Have a say in Australia's future
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaPassport className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ Australian passport – Visa-free travel to 185+ countries
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaFlag className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ Dual citizenship allowed (if your home country permits it)
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaShieldAlt className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ Full access to government benefits & services
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaGlobe className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ No residency restrictions – Live abroad without losing status
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaUsers className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ Priority sponsorship for family members
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Eligibility for Australian Citizenship */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[30px] text-2xl text-blue font-semibold hellix-font">
            Eligibility for Australian Citizenship
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[22px] mt-2 hellix-font">
          To qualify, you must meet one of the following criteria:
        </div>
        
        <div className="mt-6 space-y-6">
          {/* Citizenship by Conferral */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Citizenship by Conferral (Most Common Pathway)
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-sm" />
                <span className="text-blue hellix-font">Hold permanent residency (PR) for at least 4 years</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-sm" />
                <span className="text-blue hellix-font">Lived in Australia for at least 3 years (with no more than 12 months abroad)</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-sm" />
                <span className="text-blue hellix-font">Passed the citizenship test (if aged 18-59)</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-sm" />
                <span className="text-blue hellix-font">Meet good character requirements (no serious criminal record)</span>
              </div>
            </div>
          </div>

          {/* Citizenship by Descent */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-green-600 text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Citizenship by Descent (For Overseas-Born Children of Australians)
              </h3>
            </div>
            <div className="ml-16">
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-sm" />
                <span className="text-blue hellix-font">At least one parent was an Australian citizen at the time of your birth</span>
              </div>
            </div>
          </div>

          {/* Citizenship for PR Married to Australians */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-purple-600 text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Citizenship for Permanent Residents Married to Australians
              </h3>
            </div>
            <div className="ml-16">
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-sm" />
                <span className="text-blue hellix-font">Married to an Australian citizen + PR for 2+ years</span>
              </div>
            </div>
          </div>

          {/* Special Eligibility */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-orange-600 text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">4</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Special Eligibility (Refugees, Former Citizens, etc.)
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Step-by-Step Application Process */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={applicationProcess} alt="Application Process" />
          </div>
          <h1 className="lg:text-[30px] text-2xl text-blue font-semibold hellix-font">
            Step-by-Step Citizenship Application Process
          </h1>
        </div>
        
        <div className="mt-6 space-y-6">
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Check Eligibility
              </h3>
            </div>
            <div className="ml-16">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Confirm you meet residency & PR requirements.</span>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Prepare Documents
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Proof of identity (passport, birth certificate)</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">PR visa grant notice</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Residency evidence (rental agreements, employment records)</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">English test results (if required)</span>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Pass the Citizenship Test (If Applicable)
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">20 multiple-choice questions on Australian values, history, and government</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">75% score required to pass</span>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">4</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Lodge Your Application Online
              </h3>
            </div>
            <div className="ml-16">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Submit via the Department of Home Affairs (fee: AUD $560 for adults).</span>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">5</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Attend Citizenship Ceremony
              </h3>
            </div>
            <div className="ml-16">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Take the pledge of allegiance and receive your certificate.</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 bg-blue-50 p-4 rounded-lg">
          <p className="text-blue hellix-font text-lg">
            📌 <strong>Processing Time:</strong> 6-12 months (varies by case)
          </p>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global for Citizenship Applications?
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaAward className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 Expert Guidance – Avoid common mistakes that delay approvals.
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaGraduationCap className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 Test Preparation Support – Free study materials for the citizenship test.
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaClock className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 Fast Processing – We ensure accurate, complete applications.
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaHandshake className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 Post-Citizenship Assistance – Passport applications & family sponsorship.
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl text-blue font-bold hellix-font mb-4">
            Ready to Become an Australian Citizen?
          </h2>
          <p className="text-blue text-lg hellix-font mb-6">
            📞 Contact Immiget Global for a free eligibility check!
          </p>
          <button 
            onClick={scrollToContact}
            className="px-8 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
          >
            Get Free Eligibility Check
          </button>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className="lg:text-[34px] text-2xl text-center text-blue font-semibold hellix-font">
          FAQs
        </h1>
        <p className="text-blue font-normal text-lg lg:text-[22px] text-center hellix-font">
          Get answers to common questions about Australian Citizenship.
        </p>

        <div className="accordion-container mt-8">
          {faqs.map((faq, index) => (
            <div key={index} className="accordion mt-2">
              <div
                className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
                onClick={() => toggleAccordion(index)}
              >
                <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                  ❓ {faq.question}
                </h2>
                {activeIndex === index ? <FaTimes /> : <FaPlus />}
              </div>
              {activeIndex === index && (
                <div className="accordion-content p-4">
                  <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials Section */}
      <Testimonials 
        testimonials={testimonials} 
        title="Testimonials"
      />

      {/* How We Help Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-lg:flex-col justify-between gap-6 lg:gap-[80px] lg:items-center">
          <div className="lg:w-[50%]">
            <div className="flex gap-2">
              <div className="flex items-center">
                <img src={helpIcon} alt="help" />
              </div>
              <h1 className="text-[30px] text-blue font-semibold hellix-font">
                How Immiget Global Can Help
              </h1>
            </div>
            <p className="hellix-font text-blue text-lg font-normal mt-4">
              Our experienced citizenship specialists understand the importance of becoming an Australian citizen and the opportunities it provides. We provide comprehensive support throughout the entire citizenship process, from initial eligibility assessment to attending your citizenship ceremony. With our expertise and personalized guidance, we ensure your citizenship application is handled professionally and efficiently.
            </p>
            <div className="flex gap-4 mt-6">
              <button 
                onClick={scrollToContact}
                className="px-6 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
              >
                Contact Us Today
              </button>
            </div>
          </div>
          <div className="lg:w-[50%] max-lg:justify-center max-lg:flex">
            <img src={helpImage} alt="How we can help" />
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default Citizenship;